export const setButtonLabel = (button: HTMLButtonElement, value: string) => {
    const label = button.querySelector<HTMLSpanElement>('.button__label');
    label && (label.innerText = value);
};
